// 问题初始化列表配置
const topics = () => [
  {
    topic_name: '',
    isOpen: true,
    option_type: 1,
    options: [
      {
        option_name: '',
        option_img: '',
      },
      {
        option_name: '',
        option_img: '',
      },
    ],
  },
];

export { topics };
